// Small formatting helpers shared between the admin Job Dashboard
// (jobDashboard.jsx) and the read-only JobApplicationView used both there
// and on the candidate's own /my-job-applications page -- kept in one place
// so document type labels/sizes never drift between the two surfaces.
export const APPLICATION_DOCUMENT_TYPE_LABELS = {
  cv: "CV / Resume",
  cover_letter: "Lettre de motivation",
  diploma: "Diplome",
  certificate: "Certificat",
  portfolio: "Portfolio",
  other: "Autre",
};

export const formatFileSize = (size = 0) => {
  const value = Number(size || 0);
  if (!value) return "";
  if (value < 1024 * 1024) return `${Math.round(value / 1024)} KB`;
  return `${Math.round((value / (1024 * 1024)) * 10) / 10} MB`;
};

// Same check jobApplicationsAdmin.jsx already used for its inline preview
// modal (kept identical so the in-app document preview behaves exactly the
// same everywhere it's used).
export const isImageUrl = (url = "") => /\.(png|jpe?g|webp|gif|svg)(\?.*)?$/i.test(String(url));
